import { propertiesApi, rentalAgreementsApi, type PropertyListItemDto, type RentalAgreementDto } from '../../services/api';
import { onLocaleChange } from '../../services/i18n';
import { t } from '../../services/i18n';
import './rc-contract-timeline-view';
import { RcContractTimelineView } from './rc-contract-timeline-view';

export class RcContractTimeline extends HTMLElement {
  private properties: PropertyListItemDto[] = [];
  private agreements: RentalAgreementDto[] = [];
  private disposeLocaleChange?: () => void;

  async connectedCallback(): Promise<void> {
    this.innerHTML = `<div class="contract-timeline-skeleton">${[1, 2, 3, 4].map(() => `<div class="contract-timeline-skeleton-row"></div>`).join('')}</div>`;
    this.disposeLocaleChange = onLocaleChange(() => this.render());
    try {
      [this.properties, this.agreements] = await Promise.all([
        propertiesApi.getAll(),
        rentalAgreementsApi.getAll(),
      ]);
      this.render();
    } catch (error: any) {
      this.innerHTML = `<div class="empty-state">${t('contractTimeline.loadError')}: ${error.message}</div>`;
    }
  }

  disconnectedCallback(): void {
    this.disposeLocaleChange?.();
  }

  private render(): void {
    this.innerHTML = '<rc-contract-timeline-view></rc-contract-timeline-view>';
    const view = this.querySelector('rc-contract-timeline-view') as RcContractTimelineView | null;
    if (!view) return;
    view.properties = this.properties;
    view.agreements = this.agreements;
    view.render();
  }
}

if (!customElements.get('rc-contract-timeline')) {
  customElements.define('rc-contract-timeline', RcContractTimeline);
}
